import * as React from 'react';
import { Transition } from 'react-transition-group';
import styled from 'styled-components';
import LinkList from './link_list';
import MobileFooter from './mobile_footer';
import MobileMenuHeader from './mobile_menu_header';

const duration = 300;

const ScreenOverlay = styled.nav`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: fixed;
  top: 0;
  width: 100%;
  background: ${({ theme }) => theme.backgroundColor};
  z-index: 1;
  overflow: hidden;
  padding: 20px;

  height: 100vh;

  left: ${({ status }) => {
    switch (status) {
      case 'exited':
        return '100%';
      default:
        return '0';
    }
  }};

  opacity: ${({ status }) => {
    switch (status) {
      case 'entering':
      case 'entered':
        return 1.0;
      default:
        return 0.0;
    }
  }};
  transition: opacity ${duration}ms;
`;

const Menu = styled.div`
  display: flex;
  flex: auto;
  flex-direction: column;
`;

class MobileMenuWrapper extends React.PureComponent {
  render() {
    const { isOpen, toggleOpen } = this.props;
    return (
      <Transition in={isOpen} timeout={duration}>
        {status => {
          const isOpen = status === 'entering' || status === 'entered';
          return (
            <ScreenOverlay status={status} role="navigation" aria-expanded={isOpen} aria-label="Main menu">
              <Menu>
                <MobileMenuHeader toggleOpen={toggleOpen} />
                <LinkList toggleOpen={toggleOpen} />
              </Menu>
              <MobileFooter />
            </ScreenOverlay>
          );
        }}
      </Transition>
    );
  }
}

export default MobileMenuWrapper;
